<template>
  <div class="form__form-error">
    <ul v-for="(error, index) in formErrors" :key="index">
      <li>{{ typeof error == 'object' ? error[0] : error }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FormError',
  props: {
    formErrors: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/forms';

li {
  list-style-type: disc;
  margin-left: 1rem;
}
</style>
